import React, { useMemo, useState } from 'react';
import { OverlayTrigger, Popover, Table } from 'react-bootstrap';
import { InfoCircle } from 'react-bootstrap-icons';
import useLocalization from '../../hooks/useLocalization';
import LTRNumberCell from '../common/LTRNumberCell';

const Summary = ({ data, extraInfo: { timeLabel } }) => {
  const { translate } = useLocalization();
  const [showPopover, setShowPopover] = useState(false);

  const dataRows = useMemo(
    () =>
      Object.keys(data).sort((a, b) => {
        if (a === 'Begin') return -1;
        if (b === 'Begin') return 1;
        return a - b;
      }),
    [data]
  );
  const PopoverModal = (
    <Popover onClick={e => e.stopPropagation()} style={{ minWidth: 600 }} id="popover-positioned-left">
      <Popover.Header className="p-1 fw-bold bg-light-blue text-white">{translate('break_down')}</Popover.Header>
      <Popover.Body className="p-0" style={{ maxHeight: '70vh', overflowY: 'auto', overflowX: 'hidden' }}>
        <Table striped bordered hover className="bg-white m-0 mb-0">
          <tbody>
            {dataRows?.map(row => {
              return (
                <>
                  <tr className="bg-dark text-white px-2 no-pointer-events py-1">
                    <td colSpan={2} className="text-white fw-bold py-1">
                      {translate(timeLabel) || timeLabel} {row}
                    </td>
                  </tr>
                  {data?.[row]?.map(dataRow => {
                    return (
                      <tr>
                        <td className="fw-bold py-1"> {translate(dataRow?.description) || dataRow?.description}</td>{' '}
                        <td className="py-1">
                          <LTRNumberCell value={dataRow?.cashflow} formatType="currency" />
                        </td>
                      </tr>
                    );
                  })}
                  <tr className="bg-light-blue-3">
                    <td className="py-1 text-dark ">
                      <span className="fw-bold">{translate('total')}</span>{' '}
                    </td>
                    <td className="py-1 text-dark">
                      <LTRNumberCell
                        value={data?.[row]?.reduce((total, transaction) => {
                          return total + transaction.cashflow;
                        }, 0)}
                        formatType="currency"
                      />
                    </td>
                  </tr>
                </>
              );
            })}{' '}
          </tbody>
        </Table>
      </Popover.Body>
    </Popover>
  );
  return (
    <>
      {showPopover && (
        <div
          style={{
            position: 'fixed',
            zIndex: 1040,
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.6)'
          }}
          onClick={() => setShowPopover(false)}
        />
      )}
      <OverlayTrigger
        rootClose
        trigger="click"
        placement="auto"
        overlay={PopoverModal}
        show={showPopover}
        onToggle={setShowPopover}
      >
        <InfoCircle
          className="mx-2 hover text-primary-new"
          size={15}
          style={{ cursor: 'pointer' }}
          onClick={() => setShowPopover(!showPopover)}
        />
      </OverlayTrigger>
    </>
  );
};

export default Summary;
